import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	GetPrescriptionsList,
	GetPrescriptionsListModel,
	GetPrescriptionsListParams,
} from 'domain/usecases/private/my-hospitalization/get-prescriptions-list';

export class RemoteGetPrescriptionsList implements GetPrescriptionsList {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<GetPrescriptionsListModel>,
	) {}

	async get({signal, ...params}: GetPrescriptionsListParams): Promise<GetPrescriptionsListModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'get',
			params,
			signal,
		});

		switch (httpResponse.status) {
			case HttpStatusCode.ok:
				return httpResponse.data;
			case HttpStatusCode.created:
				return httpResponse.data;
			case HttpStatusCode.noContent:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
